export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 p-8 md:p-10 rounded-lg bg-primary-600">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-4">
                随时随地，掌上吃瓜
              </h2>
              <p className="text-sm md:text-base text-primary-100 leading-relaxed mb-6">
                黑料每日大赛移动客户端已上线！支持 iOS 和 Android，推送更及时，吃瓜更便捷。下载 App 即可享受专属推送通知，重大爆料第一时间弹窗提醒，绝不错过任何一口热瓜。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#hero"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-700 rounded-full font-semibold text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer no-underline"
                >
                  <i className="ri-apple-line text-lg"></i>
                  App Store 下载
                </a>
                <a
                  href="#hero"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-800 text-background-50 rounded-full font-semibold text-sm hover:bg-primary-900 transition-colors whitespace-nowrap cursor-pointer no-underline border border-primary-400/40"
                >
                  <i className="ri-android-line text-lg"></i>
                  安卓版下载
                </a>
              </div>
            </div>
            <div className="w-48 md:w-56 lg:w-64 shrink-0">
              <div className="aspect-[3/4] rounded-lg overflow-hidden bg-primary-800 flex items-center justify-center">
                <div className="text-center text-primary-200 p-4">
                  <i className="ri-smartphone-line text-5xl md:text-6xl mb-3 block"></i>
                  <span className="text-xs md:text-sm font-medium">黑料每日大赛</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}